export const PKG_VERSION = process.env.PKG_VERSION || '-dev';
